import { dateSorter, periodRenderer } from '@lib/generic.utils'
import { agPriceCol } from '@/ag-grid/ag-columns'

export default {
  computed: {
    gridOptions() {
      return {
        rowData: this.licenses,
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            sort: 'asc',
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/licenses/${params.data.license_id}`
              }
            }
          },

          {
            headerName: 'Manager',
            field: 'owner.name',
            tooltipField: 'owner.name'
          },

          agPriceCol('Subscriptions', 'subscriptions_count', {
            cellRenderer: params => params.value ?? 0,
            maxWidth: undefined
          }),

          {
            headerName: 'Period',
            comparator: dateSorter,
            cellRenderer: params => periodRenderer(params.data),
            tooltipValueGetter: params => periodRenderer(params.data)
          }
        ]
      }
    }
  }
}
